import React, {Component} from 'react';
import {Link} from "react-router-dom";
import moment from "moment";
import '../style/TicketsPage.scss';
import Context from "../tools/context";
import {clientT, t} from "../tools/i18n";
import AppLink from './AppLink';
import AppButton from './AppButton';
import {track} from "../tools/tracking";

class ConfirmedTicket extends Component {
  componentDidMount() {
    const {selectedTickets, sellerShortCode} = this.props;

    if (!Array.isArray(selectedTickets)) return;
    track('viewTicketConsumer', {
      prize: selectedTickets.map(ticket => ticket.prize).join('|'),
      uuid: selectedTickets.map(ticket => ticket.uuid).join('|'),
      shortcode: sellerShortCode
    });
  }

  renderDetails = () => {
    const {selectedTickets, sellerName} = this.props;
    const total = selectedTickets.reduce((acc, t) => acc + t.value, 0);
    const totalThreshold = selectedTickets.reduce((acc, t) => acc + t.threshold, 0);
    const codes = selectedTickets.map(t => t.prize).join(', ');
    const condition = selectedTickets[0].condition || '';
    const fields = [
      {name: clientT('myTickets.step3.amount'), value: `${total}€${totalThreshold ? ` dès ${totalThreshold}€ d'achat` : ''}`},
      {name: clientT('myTickets.step3.date', {count: selectedTickets.length}),
        value: `${moment().format('DD/MM/YYYY')} à ${moment().format('H[h]mm')}`},
      {name: clientT('myTickets.step3.recipient'), value: sellerName},
      {name: clientT('myTickets.step3.conditions'), value: <span dangerouslySetInnerHTML={{__html: condition}}/> },
      {name: clientT('myTickets.step3.code', {count: selectedTickets.length}),
        value: codes, className: 'smaller'},
    ];

    return fields.map((f, i) => (
      <div key={i} className={f.className}>
        {f.name} :
        <div className="data">{f.value}</div>
      </div>
    ))
  }

  render() {
    const refundPrizes = encodeURIComponent(this.props.selectedTickets.map(p => p.prize).join('|'))

    return (
      <div className="confirmed-ticket">
        <div className='my-tickets-container' style={{paddingBottom: '24px'}}>
          <div className="sellerName">{Context.partner?.client?.noThanks
            ? clientT('myTickets.step3.titleNoThanks')
            : clientT('myTickets.step3.title', {partnerName: this.props.sellerName})
          }</div>
          {Context.features.kawaiiMode &&
            <img src={'/assets/icons/shibaTCA.png'} style={{width: 'auto', height: '110px'}}/>
          }
          <div className="detail">
            {this.renderDetails()}
          </div>
          {/*<p> N'oubliez pas de revenir dès lundi prochain pour télécharger vos 10 nouveaux Tickets My Provence !</p>*/}
          <div className="explaination"> {Context.partner?.client?.confirmationText
          || clientT('myTickets.step3.instruction')}</div>
          {/*<p>Vous pouvez consulter votre historique dans la section Mes tickets utilisés</p>*/}
          <AppButton
            onClick={this.props.reset}
            event="Terminer"
            client
            className='mainButton'>{t('common.finish')}
          </AppButton>
          {!this.props.popup &&
            <AppLink href='/mes-tickets-utilisés' client>
              <AppButton className='secButton'>{clientT('myTickets.step3.showUsed')}
              </AppButton>
            </AppLink>
          }
          {Context.partner.features.allowUserRefund &&
            <div className="refundBlock">
              <div className="separator"/>
              <AppLink href={`/refund/ask/${this.props.sellerShortCode}/${refundPrizes}`}
                       dangerouslySetInnerHTML={{__html: clientT('refund.goto')}}
              /></div>
          }
        </div>
      </div>
    );
  }
}

export default ConfirmedTicket;
